import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Process } from 'src/app/core/models/process.model';
import { DatePipe, CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { Router } from '@angular/router';

@Component({
  selector: 'app-process-preview-dialog',
  standalone: true,
  template: `
    <h1 mat-dialog-title>Detalhes do Processo</h1>
    <div mat-dialog-content>
      <p><strong>N. do Processo:</strong> {{ data.numeroProcesso || 'Não disponível' }}</p>
      <p><strong>Empresa:</strong> {{ data.empresa || 'Não informado' }}</p>
      <p><strong>Descrição:</strong> {{ data.descricao || 'Não disponível' }}</p>
      <p><strong>Modalidade:</strong> {{ data.idModalidade || 'Não informado' }}</p>
      <p><strong>Fase:</strong> {{ data.fase || 'Não informado' }}</p>
      <p><strong>Data de Inclusão:</strong> {{ data.registerDate | date: 'dd/MM/yyyy' || 'Data não disponível' }}</p>
      <p><strong>Situação:</strong> {{ data.situacao || 'Não informado' }}</p>
      <p><strong>Prazo:</strong> {{ data.dueDays ? data.dueDays + ' dias' : 'Não informado' }}</p>
      <p><strong>Grupo:</strong> {{ data.idModalidadeGrupo || 'Não informado' }}</p>
      <p><strong>Cadastro do Imóvel:</strong> {{ data.imovel.codigo || 'Não informado' }}</p>
    </div>
    <div mat-dialog-actions>
      <button mat-button mat-dialog-close>Fechar</button>
      <button mat-button color="primary" (click)="viewFullProcess()">Visualizar Processo Completo</button>
    </div>
  `,
  imports: [
    MatDialogModule,
    DatePipe,
    CommonModule,
    MatButtonModule,
    MatCardModule,
  ],
})
export class ProcessPreviewDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Process,
    private dialogRef: MatDialogRef<ProcessPreviewDialogComponent>,
    private router: Router
  ) {}

  getStatusClass(status: string): string {
    switch (status) {
      case 'Completed':
        return 'status-completed';
      case 'In Progress':
        return 'status-in-progress';
      case 'Pending':
        return 'status-pending';
      default:
        return 'status-unknown';
    }
  }

  viewFullProcess(): void{
    this.dialogRef.close();
    this.router.navigate(['/process', this.data.id]);
  }
}